module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-month-09d2cfc5.svg";